import { OrderCheckoutState } from '@shared/types';
import { FunctionComponent } from 'react';
import { useOrderCheckoutContext } from '../../CheckoutContext/OrderContext';
import PriceStep from './PriceStep';
import { ContactDetailsStep } from '../../ContactDetailsStep';
import { PaymentStep } from './PaymentStep';
import { ConfirmationStep } from './ConfirmationStep';
import { CheckoutFlowWrapper } from '../../CheckoutFlowWrapper';

export type OrderFlowProps = {};

const OrderStep: FunctionComponent<OrderFlowProps> = () => {
    const { checkoutState } = useOrderCheckoutContext();
    switch (checkoutState.currentStep) {
        case 'price':
            return <PriceStep />;
        case 'contactDetails':
            return <ContactDetailsStep actionType="order contact details filled" />;
        case 'payment':
            return <PaymentStep />;
        case 'confirmation':
            return <ConfirmationStep />;
    }
};

const unauthenticatedSteps: Array<{ key: OrderCheckoutState['currentStep']; label: string }> = [
    {
        key: 'price',
        label: 'Offers',
    },
];

const allAuthenticatedSteps: Array<{ key: OrderCheckoutState['currentStep']; label: string }> = [
    {
        key: 'contactDetails',
        label: 'Contact Info',
    },
    {
        key: 'payment',
        label: 'Payment',
    },
    {
        key: 'confirmation',
        label: 'Confirmation',
    },
];

export const OrderFlow: FunctionComponent<OrderFlowProps> = () => {
    const { offers } = useOrderCheckoutContext();
    const hasPaidOffers = offers.some((offer) => offer.price && offer.price > 0);
    const authenticatedSteps = hasPaidOffers
        ? allAuthenticatedSteps
        : allAuthenticatedSteps.filter((step) => step.key !== 'payment');
    return (
        <CheckoutFlowWrapper
            authenticatedSteps={authenticatedSteps}
            unauthenticatedSteps={unauthenticatedSteps}
        >
            <OrderStep />
        </CheckoutFlowWrapper>
    );
};
